import React, { useEffect } from "react";
import { Container } from "react-bootstrap";
import { Content, Title, Description, Footer } from "./styles";

const SAFRA_REWARDS_URL =
  "https://www.safra.com.br/store_redirect?dlOption=safra-rewards";

const SessionExpired = () => {
  useEffect(() => {
    localStorage.removeItem("session_ready");
  }, []);

  return (
    <div className="wl-page">
      <Container>
        <Content>
          <svg
            width="56"
            height="56"
            viewBox="0 0 56 56"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            style={{ marginBottom: "24px" }}
          >
            <circle
              cx="28"
              cy="28"
              r="26"
              stroke="var(--primary-color)"
              strokeWidth="2.5"
              fill="none"
            />
            <text
              x="28"
              y="36"
              textAnchor="middle"
              fontSize="22"
              fill="var(--primary-color)"
            >
              i
            </text>
          </svg>
          <Title>Sua sessão expirou</Title>
          <Description>
            Para sua segurança, você precisa acessar o Safra Rewards novamente.
          </Description>
        </Content>
      </Container>
      <Footer>
        <button
          onClick={() => (window.location.href = SAFRA_REWARDS_URL)}
          className="btn-default-wl mt-5 text-xs font-wl-600 p-2"
        >
          ACESSAR SAFRA REWARDS NOVAMENTE
        </button>
      </Footer>
    </div>
  );
};

export default SessionExpired;
